<section id="intro">
  <h1 id="intro-hed">Equality Of Odds</h1>
  <h1 id="intro-sub">
    A Visual Introduction to Measuring and Mitigating Bias in Machine Learning
  </h1>
  <h3 id="intro__date">
    <a href="https://www.linkedin.com/in/miacarinamayer">Mia Mayer</a> &
    <a href="https://twitter.com/jdwlbr">Jared Wilber</a>, April 2023
  </h3>
</section>

<style>
  #intro {
    max-width: 600px;
    margin: 1rem auto;
    text-align: center;
    padding-top: 1rem;
  }

  #intro-hed {
    font-size: 3rem;
    margin-top: 5px;
    margin-bottom: 0;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    max-width: 100%;
    margin: auto;
    color: var(--squidink);
  }

  #intro-sub {
    font-size: 1rem;
    color: var(--squidink);
    text-align: center;
    margin: 1rem;
    opacity: 0.55;
    padding: 0.5rem;
    font-family: var(--font-main);
  }

  #intro__date {
    font-size: 0.95rem;
    color: var(--squidink);
    margin: 0px;
    margin-top: 15px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    padding-bottom: 1rem;
    font-family: var(--font-main);
  }

  /* mobile */
  @media screen and (max-width: 950px) {
    #intro-hed {
      font-size: 3.1rem;
    }

    #intro-sub {
      font-size: 1.2rem;
      padding: 2rem 0;
    }
  }
</style>
